<template>
  <div>
    <div
      id="vendorLocationsMap"
    />
  </div>
</template>

<script>
/* eslint-disable no-undef */

import { onMounted } from '@vue/composition-api'

export default {
  props: {
    locations: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const mapOptions = {
      center: {
        lat: 31.963158, lng: 35.930359,
      },
      zoom: 10,
    }
    const initMap = () => {
      const map = new google.maps.Map(document.getElementById('vendorLocationsMap'), mapOptions)
      props.locations.forEach(loc => {
        const myLatlng = new google.maps.LatLng(loc.lat, loc.lon)
        const marker = new google.maps.Marker({
          position: myLatlng,
        })
        marker.setMap(map)
      })
    }
    onMounted(() => {
      initMap()
    })
  },
}
</script>

<style scoped>
#vendorLocationsMap {
  width: 100%;
  height: 300px;
}
</style>
